import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { longestStreak } from '../lib/achievements';

/**
 * Calcula o streak atual de dias seguidos (terminando hoje ou ontem).
 */
export function useStreak(userId: string): { streak: number; loading: boolean; refresh: () => Promise<void> } {
  const [streak, setStreak] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!userId) {
      setStreak(0);
      setLoading(false);
      return;
    }
    const { data, error } = await supabase
      .from('daily_activity')
      .select('date')
      .eq('user_id', userId)
      .order('date', { ascending: false })
      .limit(120);
    if (error) {
      console.error('useStreak', error);
      setStreak(0);
    } else {
      setStreak(longestStreak((data ?? []).map((r: { date: string }) => r.date)));
    }
    setLoading(false);
  }, [userId]);

  useEffect(() => {
    load();
  }, [load]);

  return { streak, loading, refresh: load };
}
